<template>
  <div class="container">
    <div class="head">
      <div class="headline">Côté administrateur</div>
      <div class="subline">Gestion des utilisateurs</div>
    </div>
    <div class="main">
      <LoggedNav class="side-nav" :user-infos="userInfos" />
      <router-view
        @error="
          (err) => {
            error(err);
          }
        "
        @success="
          (msg) => {
            success(msg);
          }
        "
      />
    </div>
    <div />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import UserService from "../../services/UserService";
import LoggedNav from "../../components/LoggedComp/LoggedNav.vue";
import { useToast } from "vue-toastification";
export default {
  components: {
    LoggedNav,
  },
  setup() {
    const toast = useToast();

    const router = useRouter();

    const userInfos = ref({});

    const getData = async (token) => {
      try {
        const info = await UserService.me(token);
        if (info == null) {
          localStorage.removeItem("token");
          router.push("/private");
        }
        userInfos.value = info.infos;
      } catch (e) {
        error(e);
      }
    };

    onMounted(async () => {
      const token = localStorage.getItem("token");
      if (token == null || token.length == 0) {
        localStorage.removeItem("token");
        router.push("/private");
      }
      await getData(token);
    });

    const success = (msg) => {
      toast.success(msg);
    };
    const error = (err) => {
      toast.error(err, { position: "top-center"});
    };
    return {
      success,
      error,
      userInfos,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;

  .head {
    .headline {
      font-size: 30px;
      margin-top: 50px;
      font-weight: 700;
    }
    .subline {
      font-size: 20px;
      color: var(--mainGreen);
      margin-bottom: 50px;
    }
  }
  .main {
    display: flex;
    flex-direction: row;
    .side-nav {
      min-width: 23%;
      max-width: 23%;
    }
  }
}
</style>